import React, { forwardRef } from 'react'
import { Grid } from "@mui/material";
import Stack from '@mui/material/Stack';
import UiInput from '../../../../../_uiComponents/UiInput';
import { UiButton, UiToggleButton } from '../../../../../../_uiComponents/common/form/UiButton';
import UiInnerSearchWr from '../../../../../../_uiComponents/common/UiInnerSearchWr';
import UiSelect from "../../../../../../_uiMocks/_uiComponents/UiSelect"
import UiDateRangePicker from '../../../../../_uiComponents/UiDateRangePicker';


export default function MeasurementsFilterForm(props) {

    const [contains, setContains] = React.useState('');

    const handleContainChange = (event) => {
        setContains(event.target.value);
    };
    const options = [
        {value: 'value-1', label: 'text-1'},
        {value: 'value-2', label: 'text-2'},
        {value: 'value-3', label: 'text-3'}
    ];

    return (
        <>
            <UiInnerSearchWr>
                <Grid container spacing={2}>
                    <Grid item xs="12" lg="9" >
                        <Grid container spacing={2}>
                            <Grid item xs="12" lg="4"  >
                                <UiInput type="text" label="Name" />
                            </Grid>
                            <Grid item xs="12" lg="4" >
                                <UiDateRangePicker />
                            </Grid>
                            <Grid item xs="12" lg="4"  >
                                <UiSelect label="Status"
                                    value={contains}
                                    handleChange={handleContainChange}
                                    options={options} >
                                </UiSelect>
                            </Grid>
                            
                        </Grid>
                    </Grid>
                    <Grid item xs="12" lg="3" >
                        <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%', pt: 0.6 }}>
                            <UiButton name="Clear" variant="outlined" size="small" />
                            <UiButton name="Apply" variant="contained" size="small" />
                        </Stack>
                    </Grid>

                </Grid>
            </UiInnerSearchWr>



        </>
    )
}
